module.exports = __webpack_public_path__ + "img/rocket-black-24-dp.dea086ef.svg";